import { Injectable } from "@angular/core";
import { Utils } from 'fakturnia-shared';
import { DocumentsService } from "./documents.service";
import { Invoice } from "fakturnia-shared";

@Injectable({
    providedIn: 'root'
})
export class InvoicesService {
    constructor(private _documentsService:DocumentsService)
    {

    }

    public getById(invoiceId): Invoice | null
    {
        const document = this._documentsService.getById(invoiceId)
        if (!document || typeof document == 'undefined') {
          console.warn(`[InvoicesService]: Invoice with _id: ${invoiceId} not found.`)
          return null
        }

        let invoice = new Invoice().fromDbDocument(document)

        // FakturaZaliczka: jeśli brak linkedOrder, odtwórz z zamówienia
        if (invoice.documentType === 'FakturaZaliczka' && !invoice.linkedOrder && invoice.linkedOrderId) {
            const order = this._documentsService.getById(invoice.linkedOrderId)
            if (order) {
                invoice.linkedOrder = {
                    invoiceName: order.invoiceName || order.documentNumber || 'Zamówienie',
                    grossSum: order.grossSum || 0,
                    products: (order.products || []).map((p: any) => ({
                        name: p.name || '', unitOfMeasure: p.unitOfMeasure || 'szt.',
                        quantity: p.quantity || 1, netPrice: p.netPrice || 0,
                        netValue: p.netValue || 0, vatRate: p.vatRate ?? 23,
                        amountOfVat: p.amountOfVat || 0, grossValue: p.grossValue || 0
                    }))
                }
            }
        }

        if(invoice.prepaymentIds.length > 0) {
            invoice.prepayments = []
            invoice.prepaymentIds.forEach(prepaymentId => {
                const prepayment = this._documentsService.getById(prepaymentId)
                if(prepayment) invoice.addPrepayment(prepayment)
            })
        }

        if(invoice.correctedInvoiceId && !Utils.isNullOrEmpty(invoice.correctedInvoiceId)) {
            invoice.correctedInvoice = null
            const correctedInvoice = this._documentsService.getById(invoice.correctedInvoiceId)
            if(correctedInvoice) {
                // KOR_ZAL: jeśli korygowana FakturaZaliczka nie ma linkedOrder, odtwórz z zamówienia
                if (correctedInvoice.documentType === 'FakturaZaliczka' && !correctedInvoice.linkedOrder && correctedInvoice.linkedOrderId) {
                    const order = this._documentsService.getById(correctedInvoice.linkedOrderId)
                    if (order) {
                        (correctedInvoice as any).linkedOrder = {
                            invoiceName: order.invoiceName || order.documentNumber || 'Zamówienie',
                            grossSum: order.grossSum || 0,
                            products: (order.products || []).map((p: any) => ({
                                name: p.name || '', unitOfMeasure: p.unitOfMeasure || 'szt.',
                                quantity: p.quantity || 1, netPrice: p.netPrice || 0,
                                netValue: p.netValue || 0, vatRate: p.vatRate ?? 23,
                                amountOfVat: p.amountOfVat || 0, grossValue: p.grossValue || 0
                            }))
                        }
                    }
                }
                invoice.addCorrectedInvoice(correctedInvoice, false)
            }
        }

        invoice.count()
        return invoice
    }
}